module.exports = __webpack_public_path__ + "static/media/coffee_free_mobile_en.79c99223.jpg";